export class MaskUtil {
  public static MaskingConfiguration(value, startIndex, endIndex) {
    const middlePartOfPhoneNumber = value.slice(startIndex, endIndex);
    const firstDigitOfThePhoneNumber = value.substr(0, startIndex);
    const theLastDigitOfThePhoneNumber = value.slice(endIndex);
    let star = '';
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < middlePartOfPhoneNumber.length; i++) {
      star += "*";
    }
    return `${firstDigitOfThePhoneNumber}${star}${theLastDigitOfThePhoneNumber}`;
  }
}
